import './App.css';
import Header from "./Header";
import Form from "./Form";
import OutputDisplay from "./OutputDisplay";
import {useState} from "react";
import InfoSection from "./InfoSection";
import OutputFormat from "./OutputFormat";
import OutputDownload from './OutputDownload';

function App() {
    const [displayButton, setDisplayButton] = useState(false);
    const [downloadButton, setDownloadButton] = useState(false);
    const [outputText, setOutputText] = useState("");
    const [downloadActive, setActive] = useState("");
    return (
    <div className="App">
        <Header/>
        <h2>SOAR to NuXmv Translator</h2>
        <Form displayButton={displayButton} callback={setDisplayButton} setOutputText={setOutputText}/>
        { outputText.length > 0 ? (
            <OutputDisplay text={outputText}/>
        ) : ""
        }
        <OutputDownload downloadButton ={downloadButton} callback={setDownloadButton} setOutputText={setOutputText} setActive ={setActive} />
        { outputText.length > 0 ? (
            <OutputDownload text={outputText}/>
        ) : ""
        }
        <InfoSection />
        <OutputFormat />
    </div>
    );
}

export default App;
